import { HTTP } from '../services';

export default new class ContractService {
  /**
   * Create or update a contract for a lead event + venue pair.
   * Pass signature_fields: null if no fields placed yet.
   */
  createOrUpdateContract(leadEventId, payload) {
    return HTTP.post(`/v1/lead-event/${leadEventId}/contracts`, payload);
  }

  /**
   * Upload (or replace) the contract PDF.
   */
  uploadPdf(leadEventId, contractId, file) {
    const formData = new FormData();
    formData.append('contract_pdf', file);
    return HTTP.post(`/v1/lead-event/${leadEventId}/contracts/${contractId}/pdf`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  }

  /**
   * Get all contracts for a lead event (all venues), returns contracts_by_venue.
   */
  getContracts(leadEventId) {
    return HTTP.get(`/v1/lead-event/${leadEventId}/contracts`);
  }

  /**
   * Send contract to client (optionally include venue pre-signed PDF).
   */
  sendToClient(leadEventId, contractId, venuePdfFile = null) {
    const formData = new FormData();
    if (venuePdfFile) {
      formData.append('venue_signed_pdf', venuePdfFile);
    }
    return HTTP.post(`/v1/lead-event/${leadEventId}/contracts/${contractId}/send-to-client`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  }

  /**
   * Soft-delete a contract.
   */
  deleteContract(leadEventId, contractId) {
    return HTTP.delete(`/v1/lead-event/${leadEventId}/contracts/${contractId}`);
  }

  /**
   * Submit VenueCrew signed field content to the server for PDF embedding.
   */
  signContract(leadEventId, contractId, payload) {
    return HTTP.post(`/v1/lead-event/${leadEventId}/contracts/${contractId}/sign`, payload);
  }

  /**
   * Get a 30-minute pre-signed download URL for an attachment.
   * Returns the unwrapped { download_url } object.
   */
  async getDownloadUrl(leadEventId, documentId) {
    const res = await HTTP.get(`/v1/lead-event/${leadEventId}/contract-document/${documentId}/download-url`);
    return (res && res.data) || res;
  }

  /**
   * Get a pre-signed download URL for a printable copy of the contract with
   * the signing fields rendered as placeholders. Used when the client wants
   * to receive the contract as a downloadable PDF instead of signing in-app.
   * Returns the unwrapped { download_url } object.
   */
  async getPrintableCopyUrl(leadEventId, contractId) {
    const res = await HTTP.get(`/v1/lead-event/${leadEventId}/contracts/${contractId}/printable-copy-url`);
    return (res && res.data) || res;
  }
}
